import React from 'react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="w-full px-5 py-14 sm:px-8" style={{
    backgroundColor: 'var(--cream)'
  }} data-id="element-17" data-mp="32u0gvs1hkrb7">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 text-center" data-id="element-18" data-mp="32oe1fz8zkhcr">
        <Logo width={150} height={50} data-id="element-19" data-mp="36p6b2tlrso9k" />
        <p className="font-heading text-lg font-light italic" style={{
        color: 'var(--darkgoldenrod)'
      }} data-id="element-20" data-mp="36q94b86kf2sn">
          El Último Nudo · Desenredar para ascender
        </p>
        <p className="max-w-md text-sm leading-relaxed" style={{
        color: 'rgba(42,36,32,0.6)'
      }} data-id="element-21" data-mp="37xv6falryhh">
          Embajadores del Alma · 26 de noviembre — 1 de diciembre · Akalki,
          Bacalar (4 noches) + Cancún (1 noche) · 15 personas
        </p>

        <div className="w-full max-w-3xl border-t pt-6 text-left" style={{
        borderColor: 'rgba(42,36,32,0.1)'
      }} data-id="element-22" data-mp="2a19tpmiidoxa">
          <p className="text-center text-xs font-medium uppercase tracking-[0.18em]" style={{
          color: 'rgba(42,36,32,0.58)'
        }} data-id="element-23" data-mp="3lalg1f31y5ty">
            Información importante
          </p>
          <p className="mt-3 text-center text-xs leading-relaxed" style={{
          color: 'rgba(42,36,32,0.55)'
        }} data-id="element-24" data-mp="3v5n6qfcz7fyn">
            Las imágenes y fotografías de esta página son de apoyo e inspiración
            visual; no representan necesariamente los lugares, alojamientos,
            actividades o experiencias específicos que harán parte del retiro.
            El itinerario, los proveedores y los detalles de la experiencia se
            confirmarán antes de la inscripción y podrán ajustarse por
            condiciones locales, meteorológicas, operativas o de seguridad,
            manteniendo siempre el propósito y la calidad de la experiencia.
          </p>
          <p className="mt-3 text-center text-xs leading-relaxed" style={{
          color: 'rgba(42,36,32,0.55)'
        }} data-id="element-25" data-mp="tvcz5qtmo3em">
            Al compartir tus datos o solicitar información, aceptas el
            tratamiento conforme a nuestra{' '}
            <a href="https://espacioparaelalma.com/politica-privacidad/" target="_blank" rel="noreferrer" className="underline underline-offset-2 transition-opacity hover:opacity-70" style={{
            color: 'var(--darkgoldenrod)'
          }} data-id="element-26" data-mp="18k0qfkwfxqyr">
              Política de tratamiento de datos personales
            </a>
            .
          </p>
        </div>

        <p className="text-xs" style={{
        color: 'rgba(42,36,32,0.45)'
      }} data-id="element-27" data-mp="1rhk08qqq3dm8">
          © {new Date().getFullYear()} Espacio para el Alma. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}